import { getWithAuth } from './api/client';
import type {
  AvailabilityReportItem,
  DashboardSummary,
  ExperienceDistributionItem,
  GroupStatisticsItem,
  ExploreTechnologiesDistributionItem,
  ReportsFiltersState,
  SkillDistributionItem,
} from '../types/reports';

const REPORTS_BASE_URL = '/app/reports';

function toParams(filters: ReportsFiltersState) {
  return {
    skill: filters.skill || undefined,
    groupType: filters.groupType || undefined,
    availabilityType: filters.availabilityType || undefined,
  };
}

function unwrapList<T>(response: T[] | { data?: T[] }) {
  if (Array.isArray(response)) {
    return response;
  }

  return Array.isArray(response?.data) ? response.data : [];
}

export const getSkillsDistribution = async (filters: ReportsFiltersState) => {
  const response = await getWithAuth<SkillDistributionItem[] | { data?: SkillDistributionItem[] }>(
    `${REPORTS_BASE_URL}/skills-distribution`,
    toParams(filters)
  );

  return unwrapList(response);
};

export const getAvailabilityReport = async (filters: ReportsFiltersState) => {
  const response = await getWithAuth<AvailabilityReportItem[] | { data?: AvailabilityReportItem[] }>(
    `${REPORTS_BASE_URL}/availability`,
    toParams(filters)
  );

  return unwrapList(response).filter((item) => {
    const label = item.availabilityTypeName || item.availabilityType || '';
    return label.trim().toLowerCase() !== 'unknown';
  });
};

export const getExperienceDistribution = async (filters: ReportsFiltersState) => {
  const response = await getWithAuth<ExperienceDistributionItem[] | { data?: ExperienceDistributionItem[] }>(
    `${REPORTS_BASE_URL}/experience-distribution`,
    toParams(filters)
  );

  return unwrapList(response);
};

export const getGroupStatistics = async (filters: ReportsFiltersState) => {
  const response = await getWithAuth<GroupStatisticsItem[] | { data?: GroupStatisticsItem[] }>(
    `${REPORTS_BASE_URL}/group-statistics`,
    toParams(filters)
  );

  return unwrapList(response);
};

export const getDashboardSummary = async () => {
  const response = await getWithAuth<DashboardSummary | { data?: DashboardSummary }>(
    `${REPORTS_BASE_URL}/dashboard-summary`
  );

  return 'data' in response && response.data ? response.data : (response as DashboardSummary);
};

export const getExploreTechnologiesDistribution = async (filters: ReportsFiltersState) => {
  const response = await getWithAuth<ExploreTechnologiesDistributionItem[] | { data?: ExploreTechnologiesDistributionItem[] }>(
    `${REPORTS_BASE_URL}/interest-distribution`, 
    toParams(filters)
  );

  return unwrapList(response);
};
